// merchant (details, items, feedback)
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  order: {
    isOpen: false,
    // ... order
  },
};

export const slice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    clearState: (state, { payload }) => {
      state = initialState;
      return state;
    },

    toggleOrderModal: (state, { payload }) => {
      if (payload && 'isOpen' in payload) {
        state.order.isOpen = payload.isOpen;
      } else {
        state.order.isOpen = !state.order.isOpen;
      }

      // if (state.order.isOpen) {
      // 	state.order = { ...state.order, ...payload }
      // 	return state
      // }
      // state.order = {
      // 	isOpen: state.order.isOpen,
      // 	store: {},
      // }

      return state;
    },
  },
});

export const { clearState, toggleOrderModal } = slice.actions;

export default slice.reducer;
